import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Form, InputNumber } from 'antd';
import DisabledContext from 'antd/es/config-provider/DisabledContext';

const CurrencyInput = ({
  name,
  label,
  rules,
  onChange,
  required,
  disabled,
  hasFeedback,
  value,
  hidden,
  dependencies,
  ...props
}) => {
  const formDisabled = useContext(DisabledContext);
  // Mientras se está escribiendo se muestra el valor tal cual (sin forzar decimales, para no
  // interrumpir la escritura); al salir del campo (blur) se redondea a 2 decimales. AntD no
  // vuelve a invocar `formatter` solo porque este componente se re-renderice, así que se fuerza
  // un remount del InputNumber justo después del blur (cuando ya no tiene foco) para que
  // recalcule el texto mostrado con el `enfocado` ya en false.
  const [enfocado, setEnfocado] = useState(false);
  const [remountKey, setRemountKey] = useState(0);
  const defaultRule = [
    {
      required,
      message: 'El campo es requerido',
    },
  ];
  return (
    <Form.Item
      name={name}
      label={label}
      rules={rules || defaultRule}
      hasFeedback={hasFeedback}
      hidden={hidden}
      dependencies={dependencies}
    >
      <InputNumber
        key={remountKey}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        className={disabled || formDisabled ? 'custom-input-disabled' : ''}
        allowClear={hasFeedback || !disabled}
        onChange={onChange}
        onFocus={(e) => {
          setEnfocado(true);
          if (props.onFocus) props.onFocus(e);
        }}
        onBlur={(e) => {
          setEnfocado(false);
          setRemountKey((k) => k + 1);
          if (props.onBlur) props.onBlur(e);
        }}
        style={{ width: '100%' }}
        disabled={disabled || formDisabled}
        formatter={(_value) => {
          const numero = Number(_value);
          const mostrarConDecimales = !enfocado && _value !== '' && _value !== undefined
            // eslint-disable-next-line no-restricted-globals
            && !isNaN(numero);
          const valorAMostrar = mostrarConDecimales ? numero.toFixed(2) : _value;
          return `$ ${valorAMostrar ?? ''}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }}
        parser={(_value) => _value.replace(/\$\s?|(,*)/g, '')}
        value={value}
      />
    </Form.Item>
  );
};

CurrencyInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  // eslint-disable-next-line react/forbid-prop-types
  rules: PropTypes.arrayOf(PropTypes.object),
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  hasFeedback: PropTypes.bool,
  value: PropTypes.number,
  hidden: PropTypes.bool,
  dependencies: PropTypes.arrayOf(PropTypes.string),
};

CurrencyInput.defaultProps = {
  rules: null,
  onChange: null,
  onFocus: null,
  onBlur: null,
  required: false,
  disabled: false,
  hasFeedback: true,
  label: '',
  value: null,
  hidden: false,
  dependencies: undefined,
};

export default CurrencyInput;
